module.exports = __webpack_public_path__ + "static/analysis-2799baf238f7fbde1e94162da58b89f6.png";